import { motion } from "framer-motion";
import { Activity } from "lucide-react";

export default function FullScreenLoader({ label = "Loading" }) {
  return (
    <div
      data-testid="fullscreen-loader"
      className="min-h-screen bg-[#050814] flex flex-col items-center justify-center gap-6"
    >
      <div className="relative">
        <span className="absolute inset-0 rounded-2xl border border-[#0066FF]/50 animate-pulse-ring" />
        <div className="glass rounded-2xl p-4">
          <Activity className="w-7 h-7 text-[#00F0FF]" strokeWidth={1.5} />
        </div>
      </div>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: [0.3, 1, 0.3] }}
        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        className="text-xs tracking-[0.35em] uppercase text-white/40 font-light"
      >
        {label}
      </motion.p>
    </div>
  );
}
